import { DisplayProps } from 'types'

export const TITLE_MAX_WIDTH: DisplayProps<number> = {
  XLARGE: 200,
  LARGE: 200,
  MEDIUM: 150,
  SMALL: 150,
}

export const TIMER_BUTTON_SIZE: DisplayProps<number> = {
  XLARGE: 45,
  LARGE: 45,
  MEDIUM: 38,
  SMALL: 30,
}
